export interface DashboardEinstallenContinueDirectScan {
    gruppeId: number;
    /** When omitted or 0, the stepper creates the Einstall-Tierliste after open. */
    einstallTierlisteId?: number;
    kundeId?: number | null;
    /** `einstallen` = scan step (default); `review` = Prüfen & melden (Liste abschliessen). */
    initialStep?: 'einstallen' | 'review';
    /**
     * @deprecated Prefer `prefillTiere` (keeps Gewicht/Abteil/…). Still accepted as Ohrmarke-only fallback.
     */
    prefillOhrmarken?: string[];
    /**
     * Sammelstelle "Nicht gefunden" drafts — created on Einstall-Tierliste with fields applied.
     * Data stays in memory until create (not persisted before Einstallen).
     */
    prefillTiere?: DashboardSammelstellePrefillTier[];
    /** Shared Einstalldatum (yyyy-MM-dd) applied when creating prefill animals. */
    kp_einstalldatum?: string | null;
}

/**
 * Draft fields captured in Sammelstelle for animals that do not exist yet.
 * Applied only when the user actually einstalls (create on tierliste).
 */
export interface DashboardSammelstellePrefillTier {
    ohrmarke: string;
    geschlecht?: 'm' | 'w' | null;
    gewicht?: string;
    haendler?: string | null;
    haendlerId?: number | null;
    herkunft?: string | null;
    herkunftKundeId?: number | null;
    herkunftFields?: {
        herkunft_vvvo: string;
        herkunft_betrieb: string;
        herkunft_strasse: string;
        herkunft_plz: string;
        herkunft_ort: string;
        herkunft_ortsteil: string;
    } | null;
    abteil?: string | null;
    bemerkungen?: string[];
    reklamationen?: string[];
    reklamationIds?: number[];
}

/**
 * Sammelstelle handoff when Zielgruppe was not chosen yet.
 * Stepper opens on Gruppe selection; queue survives until a group is picked, then animals are created.
 */
export interface DashboardEinstallenSammelstellePrefill {
    /** @deprecated Prefer `prefillTiere`. */
    prefillOhrmarken?: string[];
    prefillTiere?: DashboardSammelstellePrefillTier[];
    kundeId?: number | null;
    kp_einstalldatum?: string | null;
}

export interface DashboardEinstallenContinueAbgangTierliste {
    tierlisteId: number;
    kundeId?: number | null;
    /** When set, skips detection (e.g. from Letzte Aktionen row). */
    transferInnerhalbBetrieb?: boolean;
    /** `tiere` = scan step (default); `ausstallen` = final Ausstallen/Umstallen form step. */
    initialStep?: 'tiere' | 'ausstallen';
}

export interface DashboardEinstallenStepperDialogData {
    continueDirectScan?: DashboardEinstallenContinueDirectScan;
    continueAbgangTierliste?: DashboardEinstallenContinueAbgangTierliste;
    /** No Zielgruppe yet — land on Gruppe, keep Ohrmarken until create. */
    sammelstellePrefill?: DashboardEinstallenSammelstellePrefill;
}

/** Shared size so Ohrmarke + scan list stay readable; maxWidth keeps small viewports. */
export const dashboardEinstallenStepperDialogLayout = {
    width: '1280px',
    maxWidth: '96vw',
    maxHeight: '92vh',
    panelClass: 'dashboard-einstallen-stepper-dialog-panel',
    autoFocus: false,
    restoreFocus: false,
};
